import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import classNames from 'classnames'

import { PATHS } from 'config/constants'
import { getHomeUrl } from 'services/environment'

const Header = ({ currentUser }) => {
  const location = useLocation()
  const isInstall = location.pathname === '/install'

  return (
    <header>
      <a href={getHomeUrl()} className='tool-name'>
        <img
          src='https://demo-system-next.s3.amazonaws.com/assets/icons/dsn-logo192.png'
          className='logo'
          alt='Adobe Demo System Next'
        />
        <span className='tool-name'>Adobe Demo System Next</span>
      </a>

      <span className='main-nav'>
        <a href='/' className='main-nav-link'>
          Home
        </a>

        <a href='/quick-setup' className='main-nav-link'>
          Setup
        </a>

        <a href='/environments' className='main-nav-link'>
          Environments
        </a>

        <a href='/tools' className='main-nav-link'>
          Tools
        </a>

        <Link to={PATHS.INSTALL} className={classNames('main-nav-link', isInstall && 'active')}>
          Mobile
        </Link>

        <a href='/status' className='main-nav-link'>
          Status
        </a>

        <a href='/help' className='main-nav-link'>
          Help
        </a>
      </span>

      <span className='current-user'>{currentUser.id}</span>
    </header>
  )
}

export default Header
